export default __webpack_public_path__ + "static/media/algorithm.7b8238f3.png";